export default {
      id: "returningTruck-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#returningTruck",
      toString: function () {
        return this.url;
      }
    }